import styled, { css } from 'styled-components';

const DivUnlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
  padding: 4vh;
  box-sizing: border-box;
`;

const title = css`
  font-family: var(--font-family-serif);
  font-size: var(--size-26);
  font-weight: bold;
  line-height: 0.92;
  text-align: center;
  color: #262626;
  margin-bottom: 3vh;
`;

const description = css`
  font-family: var(--font-family-serif);
  font-size: var(--size-18);
  line-height: 1.33;
  text-align: center;
  color: #262626;
  margin-bottom: 3vh;
`;

const warning = css`
  font-family: var(--font-family-sans);
  font-size: var(--size-16);
  line-height: 1.33;
  text-align: center;
  color: #b35900;
  background-color: #fff4e5;
  border-radius: 8px;
  padding: 1.5vh 1.5vw;
  margin-bottom: 3vh;
`;

const LabelConsent = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 0.6vw;
  width: 100%;
  font-family: var(--font-family-sans);
  font-size: var(--size-16);
  line-height: 1.3;
  text-align: left;
  color: #262626;
  margin-bottom: 4vh;
  cursor: pointer;

  input {
    margin-top: 0.4vh;
    flex-shrink: 0;
    cursor: pointer;
  }
`;

const actions = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5vh;
  width: 100%;
`;

const ButtonDecline = styled.button`
  background: none;
  border: none;
  font-family: var(--font-family-sans);
  font-size: var(--size-16);
  color: var(--color-black-02);
  text-decoration: underline;
  cursor: pointer;
`;

export default {
  DivUnlock,
  title,
  description,
  warning,
  LabelConsent,
  actions,
  ButtonDecline,
};
